import React from "react";

const Banner = () => {
  return (
    <div className=" rounded-[25px]  justisy-center">
      <div className="sm:h-44 sm:w-full w-82  h-56 bg-banner  bg-cover  rounded-[25px] mt-2 sm:mt-5 ">
        <div className="flex  flex-col md:text-[30px] relative sm:left-[30px] sm:top-[20px] text-white font-extrabold m-5 mb-6 py-3 sm:py-0">
         <span>
          GO
          <span className="ml-2 sm:w-[146.51px] w-2  text-white mt text-center sm:h-[51px]  bg-[#0049F5] rounded-[25px] text-10 px-5 sm:px-0 sm:text-[30px]">
            PRO
          </span> 
          </span>
        <div className="sm:text-[25px] my-1 text-white font-extrabold text-10 ">
          PREMIUM!
        </div>
        <div className="sm:text-[23px] w-[15rem] sm:hidden text-white font-medium  text-[18px] mt-5" >
          <p className="">Millions  <br />  of happy users <br /> choices</p>

          
        </div>
        <div className="sm:text-[18px]  w-[13rem] text-white font-medium text-[18px] md:block hidden  ">
          Millions  of 
        
           happy users choices
        </div>
        </div>
      </div>

      <div className="absolute bg-white p-2  rounded-full  place-content-center  grid sm:w-44 w-44 sm:h-44  h-44 sm:top-[170px] top-[175px] sm:right-28 right-[15px]   sm:mr-10  ">
        <img
          className=" h-32 mb-5 "
          src="https://uibfs.s3.eu-north-1.amazonaws.com/Saly-41.png"
          alt=""
        />
        <div className="absolute sm:top-[77px] sm:left-[45px]  top-20 left-10">
          <img
            className="w-[20px] h-[20px]"
            src="https://uibfs.s3.eu-north-1.amazonaws.com/Ellipse+67.png"
            alt=""
          />
        </div>
        <div className="absolute sm:top-[98px] sm:right-[40px] top-24  right-10 ">
          <img
            className="sm:w-[35px] sm:h-[35px] w-[24px] h-[24px]"
            src="https://uibfs.s3.eu-north-1.amazonaws.com/Ellipse+67+(1).png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
